import App from './App'
import router from './router/index'
import { createApp } from 'vue'
import "amfe-flexible"
import vueWechatTitle from "vue-wechat-title";
import * as ELIcons from '@element-plus/icons-vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
const app = createApp(App)
for (let iconName in ELIcons) {
    app.component(iconName, ELIcons[iconName])
}
/* eslint-disable no-new */
app.use(router).use(ElementPlus).use(vueWechatTitle).mount('#app')
